//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/SelectNXObjectList.js";
import "../Features/Features.ShipDesign.ShipNamesListBuilder.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[0,"AlgorithmVersion",1,0],[0,"AngularTolerance",1,0],[1,"CopyFrom",0,"SelectNXObject",0],[0,"CopySection",1,0],[1,"CopyTo",0,"SelectNXObjectList",0],[1,"InputObjects",0,"SelectNXObjectList",0],[0,"LinearTolerance",1,0],[0,"ObjectType",1,0],[1,"ShipNames",0,"Features.ShipDesign.ShipNamesListBuilder",0],[0,"ShowXmlReport",1,0]],[],[]];
SPLM.Features.ShipDesign.CopyObjectsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.CopyObjectsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.CopyObjectsBuilder.Type = Object.freeze({
    "Part" : "Part", "Feature" : "Feature"});

SPLM.Features.ShipDesign.CopyObjectsBuilder.VersionID = Object.freeze({
    "Nx11" : "Nx11", "Nx12" : "Nx12"});

export default SPLM;